export default __webpack_public_path__ + "static/media/about_2040.6fca3f42.webp";